module.exports = require('./helpers/bundle-url').getBundleURL('cS5WQ') + "logo.c51670a8.svg";